import React, {useContext, useState, Fragment, useEffect} from "react";
import AppProvider, { AppContext} from "../../components/AppProvider";
import { TYPES_EXERCISE } from "../Eocs/Menu";
import { Container } from "../Layout";

import { SubMenu } from "./SubMenu";
import { ResultMarker } from "./ResultMarker";
import { CircleProgress } from "./CircleProgress";
import { BarProgress } from "./BarProgress";
import { SettingButtons } from "./SettingButtons";
import { Title } from "./Title";
import { TraSubject } from "./TraSubject";
import { WeekCheckAct } from "./WeekCheckAct";
import { SetWalkTarget } from "./SetWalkTarget";
import { SetExerciseTarget } from "./SetExerciseTarget";
import { SetExerciseToday } from "./SetExerciseToday";
import { ScrollToTop } from "../common/ScrollToTop/ScrollToTop";

import { userHabit } from "../../modules/utils/UserHabit";
import { NativeAction } from "../../modules/utils/HandleWs";

export default (props) => {
    const {phonecfg} = useContext(AppContext);
    const [exType, setExType] = useState('riding');
    useEffect(()=>{
        userHabit(phonecfg, "EX110");
        NativeAction(phonecfg, "statusColor", "#7FD2C2");
    }, [phonecfg.version]);
    
    useEffect(() => {
        console.log("🚀 ~ file: RecentExercise.js ~ line 25 ~ exType", exType)
    }, [exType])
    return(
        <Fragment>
            <ScrollToTop />
            <Container Title={ TYPES_EXERCISE[0].label } /*bottom={list.length === 0 ? <Bottom /> : null}*/ goToUrl={'/'} >
                <div className="contents sub">
                    {/* 서브메뉴 */}
                    <SubMenu SUBS={TYPES_EXERCISE} code={TYPES_EXERCISE[0].code} />
                    <div className="sub-contents">
                        <div className="exercise-walk-area">
                            <div className="incont-area">
                            {/* 오늘의 걸음수 */}
                            <Title title="오늘의 걸음수" className="btn-set" />
                            {/* 운동진행 상태 마커 */}
                            <ResultMarker status="운동성공" purpose="400" />
                            {/* 걸음수 표시 */}
                            <CircleProgress topText="남은 걸음수" bottomText="목표 걸음수 " maxNum="10000" stNum="3544"/>

                            {/* 칼로리 그래프 */}
                            <BarProgress trgtBurn="400" burning="170" trgtTake="1800" taking="1251" />
                            {/* 목표설정 버튼 */}
                            <SettingButtons />
                            </div>
                        </div>

                        <div className="today-trainig">
                            {/* 오늘의 운동 타이틀, 운동기록수정 버튼 */}
                            <Title title="오늘의 운동" className="open-today-setting" textA="운동 기록수정" />

                            {/* 설정운동 표시 */}
                            <div className="in-box">
                                {/* traSubject */}
                                <TraSubject exType={exType} />
                                {/* week Check Act */}
                                <WeekCheckAct />
                            </div>

                        </div>
                    </div>
                </div>
            </Container>
            <SetWalkTarget />
            <SetExerciseTarget excsInfo={excsInfo} setExType={setExType} />
            <SetExerciseToday excsInfo={excsInfo} setExType={setExType} />
        </Fragment>
    );
}

const excsInfo = [
    {
        code: "walk",
        label: "걷기",
        intensity: [
            { code: "", text: "천천히" },
            { code: "", text: "보통으로" },
            { code: "", text: "빠르게" }
        ]
    },
    {
        code: "walk2",
        label: "산책",
        intensity: [
            { code: "", text: "가볍게" },
            { code: "", text: "약간빠르게" },
            { code: "", text: "빠르게" },
            { code: "", text: "매우빠르게" }
        ]
    },
    {
        code: "running",
        label: "달리기",
        intensity: [
            { code: "", text: "보통으로" },
            { code: "", text: "가볍게" },
            { code: "", text: "약간빠르게" },
            { code: "", text: "빠르게" },
            { code: "", text: "전력질주" }
        ]
    },
    {
        code: "swim",
        label: "수영",
        intensity: [
            { code: "", text: "느리게" },
            { code: "", text: "빠른속도" },
            { code: "", text: "중간속도" },
        ]
    }
];